export default "__VITE_ASSET__DoKMfx2C__"